import { render, staticRenderFns } from "./BrElement.vue?vue&type=template&id=c60c5188&scoped=true&"
import script from "./BrElement.vue?vue&type=script&lang=js&"
export * from "./BrElement.vue?vue&type=script&lang=js&"
import style0 from "./BrElement.vue?vue&type=style&index=0&id=c60c5188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c5188",
  null
  
)

export default component.exports